<well-signup-card-layout>
  <well-payment-method-pending
    (confirmPayment)="onConfirmPayment()"
    (retryPayment)="onRetryPayment()"
    (missingPendingPayment)="onMissingPendingPayment()"
    body
  >
  </well-payment-method-pending>
</well-signup-card-layout>


